// extracted by mini-css-extract-plugin
module.exports = {"section":"Portfolio_section__1U0vW","projects-line":"Portfolio_projects-line__2FNIY"};